module.exports = __webpack_public_path__ + "assets/images/USD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD20.png
// module id = 1455
// module chunks = 1